import React from 'react';
import { Device } from 'DeviceUtils';

import WebPromoCarousel from './WebPromoCarousel';
import PromoCarousel from './PromoCarousel';

const PlatformPromoCarousel = (props) =>
    Device.isWeb ? (
        <WebPromoCarousel
            {...props}
            renderCarousel={(renderProps) => <PromoCarousel {...renderProps} />}
        />
    ) : (
        <PromoCarousel {...props} />
    );

export default PlatformPromoCarousel;
